import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.define-property.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.array.index-of.js';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.string.match.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.search.js';
import { getFingerprint } from '@mx/fsp-mweb-bridge';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var getApp_1 = createCommonjsModule(function (module, exports) {
  /**
   * 判断当前 APP
   * 需要传递 utm_campaign 参数
   *
   * ### Example
   * ```
   * const app = getApp('AgroupBgroupD300Gmine_walletH0');
   * ```
   */

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.AppUA = {
    group: /meituangroup/,
    // 外卖为了兼容5的版本，故没有用包名
    waimai: /meituanwaimai-c|takeoutnew/,
    waimaiB: /meituanwaimai(-b|business)/,
    'dianping-nova': /com\.dianping\./,
    conch: /conch/,
    movie: /movie/,
    QCSC: /qcsc\/com\.meituan/,
    weibo: /weibo/,
    weixin: /micromessenger/,
    mqq: /qq\//,
    alipay: /alipayclient/,
    daxiang: / xm\//,
    saori: /saori/,
    moma: /moma/,
    retail: /iretail|retail\.c/,
    zhenguo: /phoenix/,
    mtmaicai: /com\.(baobaoaichi\.imaicai|meituan\.(imaicai\.ep|retail\.v\.android|retail\.v\.android))/
  };

  function getApp(campaign, userAgent) {
    var appName = Object.keys(exports.AppUA);
    var ua = (userAgent || navigator.userAgent).toLowerCase();

    for (var i = 0, l = appName.length; i < l; i++) {
      if (exports.AppUA[appName[i]].test(ua)) {
        return appName[i];
      }
    }

    if (campaign) {
      var posA = campaign.indexOf('A') + 1;
      var posB = campaign.indexOf('B');
      posB = posB === -1 ? campaign.length : posB;
      return campaign.substring(posA, posB);
    }

    return /titansx/.test(ua) ? 'unknown-app' : 'web';
  }

  exports.getApp = getApp;
});

function getSystem() {
  // 根据window是否存在判断是webview类容器还是node服务器
  if (typeof window === 'undefined') {
    return 'node';
  }

  var ua = navigator.userAgent.toLowerCase();
  if (/android/.test(ua)) return 'android';
  if (/ios|iphone|ipod|ipad/.test(ua)) return 'ios';
  if (/macintosh/.test(ua)) return 'mac';
  if (/windows/.test(ua)) return 'windows';
  return 'unknown';
}

var getSystem_2 = getSystem;

function decode(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return void 0;
  }
}

var decode_2 = decode;
var decode_1$1 = /*#__PURE__*/Object.defineProperty({
  decode: decode_2
}, '__esModule', {
  value: true
});

var decode_1 = decode_1$1;

/**
 * 获取所有 query string
 *
 * ### Example
 * ```
 * const queryString = getAllQueryString();
 * const { token, entry, version } = queryString;
 * ```
 */


function getAllQueryString() {
  var arr = location.search.substr(1).split('&');
  var result = {};

  for (var i = 0, l = arr.length; i < l; i++) {
    var item = arr[i].split('=');
    var key = item.shift();
    result[key] = decode_1.decode(item.join('='));
  }

  return result;
}

var getAllQueryString_2 = getAllQueryString;
var getAllQueryString_1 = /*#__PURE__*/Object.defineProperty({
  getAllQueryString: getAllQueryString_2
}, '__esModule', {
  value: true
});

/**
 * 根据UA 读取信息
 */


function getUA() {
  var lua = (navigator.userAgent + '').toLowerCase();
  var VER_REG_STR = '([0-9][0-9.a-zA-Z_]*)';

  var regexp = function regexp(str) {
    return new RegExp(str, 'i');
  };

  var isstr = function isstr(str) {
    return typeof str === 'string';
  };

  var href = location.href;
  var qs = getAllQueryString_1.getAllQueryString();
  var apps = {
    dianping: [/com\.dianping\.ba.\w+/, /com\.dianping\.\w+/],
    meituan: ['meituangroup', /com.meituan.imeituan-?\w+/],
    maoyanpro: ['moviepro', 'moviepro/android'],
    maoyan: ['movie'],
    moma: ['moma'],
    daxiang: ['xm'],
    wechat: ['micromessenger'],
    qq: ['qq'],
    unknown: ['never_match_anything']
  };

  var appName = function () {
    var names = Object.keys(apps);

    for (var i = 0; i < names.length; i++) {
      var matchers = apps[names[i]];

      for (var j = 0; j < matchers.length; j++) {
        if (isstr(matchers[j]) ? regexp('\\W' + matchers[j] + '\\W').test(lua) : matchers[j].test(lua)) return names[i];
      }
    }

    return 'unknown';
  }();

  var appVersion = function () {
    var matchers = apps[appName];

    for (var i = 0; i < matchers.length; i++) {
      var mstring = isstr(matchers[i]) ? matchers[i] : matchers[i].source;
      var m_1 = lua.match(regexp(mstring + ' ' + VER_REG_STR)) || lua.match(regexp(mstring + '/' + VER_REG_STR));
      if (m_1) return m_1[1];
    }

    return '0';
  }();

  var osName = function () {
    if (/android/.test(lua)) return 'android';
    if (/ios|iphone|ipod|ipad/.test(lua)) return 'ios';
    if (/macintosh/.test(lua)) return 'mac';
    if (/windows/.test(lua)) return 'windows';
    return 'unknown';
  }();

  var osVersion = function () {
    var m; // https://developer.chrome.com/multidevice/user-agent
    // order matters!

    if (osName === 'android') m = lua.match(regexp('android ' + VER_REG_STR)) || lua.match(regexp('android/' + VER_REG_STR));
    if (osName === 'ios') m = lua.match(regexp(VER_REG_STR + ' like Mac OS X')) || lua.match(regexp('iOS/' + VER_REG_STR)); // 通常而言mac/window的版本不重要，无视之

    return (m ? m[1] : '0').replace(/_/g, '.');
  }(); // internal version info
  // MATCHED INDEX:     1  2              3      4             5       6
  // EXAMPLE:         KNB/1.1.0         Android/5.1     MeituanGroup/7.3.1


  var reg1 = regexp("(KNB)/" + VER_REG_STR + " (\\w+)/" + VER_REG_STR + " (\\w+)/" + VER_REG_STR);
  var reg2 = regexp("(KNB)/" + VER_REG_STR + " (\\w+)/" + VER_REG_STR + " ([a-z1-9A-Z_.-]+/[a-z1-9A-Z_.-]+)/" + VER_REG_STR);
  var m = lua.match(reg1) || lua.match(reg2);

  var _knbVersion = m && m[2]; // Try KNB Generic Mode


  if (appName === 'unknown' && m) {
    appName = m[5];
    appVersion = m[6];
  } // God knowns who you are


  if (appName === 'unknown') {
    // waimai app
    if (href.indexOf('wm_ctype=') > -1) appName = 'waimai'; // meituan like app < 7.0

    if (/iphone|ipod|ipad|android/.test(href)) {
      if ((qs.utm_campaign || '').indexOf('Agroup') > -1) appName = 'meituan';
      appVersion = qs.version_name;
    }
  }

  var matchTitansVerison = lua.match(regexp("(TitansX|TitansNoX)/" + VER_REG_STR));
  var titansxVersion = matchTitansVerison && matchTitansVerison[2];
  return {
    appName: appName,
    appVersion: appVersion,
    osName: osName,
    osVersion: osVersion,
    titansxVersion: titansxVersion,
    _knbVersion: _knbVersion
  };
}

var getUA_1 = getUA;

/**
 * 获取所有 cookie
 *
 * ### Example
 * ```
 * const cookies = getAllCookie();
 * const { uuid, token, userid } = cookies;
 * ```
 */


function getAllCookie() {
  var cookies = document.cookie.split('; ');
  var result = {};

  for (var i = 0, l = cookies.length; i < l; i++) {
    var item = cookies[i].split('=');
    var key = item.shift();
    result[key] = decode_1.decode(item.join('='));
  }

  return result;
}

var getAllCookie_2 = getAllCookie;

var Runtime;

(function (Runtime) {
  Runtime[Runtime["Prod"] = 0] = "Prod";
  Runtime[Runtime["Staging"] = 1] = "Staging";
  Runtime[Runtime["Test"] = 2] = "Test";
  Runtime[Runtime["Dev"] = 3] = "Dev";
  Runtime[Runtime["Local"] = 4] = "Local";
})(Runtime || (Runtime = {}));

var Env = /*#__PURE__*/_createClass(function Env() {
  var _this = this;

  _classCallCheck(this, Env);

  this.isNative = /titans(no)?x/i.test(navigator.userAgent);
  var cookies = getAllCookie_2();
  var urlParams = getAllQueryString_2();
  this.queryStrings = getAllQueryString_2();

  if (/\.dev\.sankuai\.com/.test(location.host)) {
    this.runtime = Runtime.Dev;
    this.pgyEnv = 'test';
  } else if (/\.test\.sankuai\.com/.test(location.host)) {
    this.runtime = Runtime.Test;
    this.pgyEnv = 'test';
  } else if (/\.st\.(sankuai|meituan)\.com/.test(location.host)) {
    this.runtime = Runtime.Staging;
    this.pgyEnv = 'st';
  } else if (/\.meituan\.com/.test(location.host)) {
    this.runtime = Runtime.Prod;
    this.pgyEnv = 'prod';
  } else {
    this.runtime = Runtime.Local;
    this.pgyEnv = 'test';
  }

  this.ecnyHomeUrl = 'https://ecny.meituan.com/ecny/home/index.html';

  if (this.runtime === Runtime.Staging) {
    this.ecnyHomeUrl = 'http://stable.pay.st.sankuai.com/ecny/home/index.html';
  }

  if (this.runtime === Runtime.Test) {
    this.ecnyHomeUrl = 'http://stable.pay.test.sankuai.com/ecny/home/index.html';
  }

  if (this.runtime === Runtime.Prod) {
    this.ecnyHomeUrl = 'https://ecny.meituan.com/ecny/home/index.html';
  }

  var getParam = function getParam() {
    for (var i = 0, len = arguments.length; i < len; i++) {
      var name = i < 0 || arguments.length <= i ? undefined : arguments[i];
      var param = cookies[name] || urlParams[name];

      if (param) {
        return param;
      }
    }

    return '';
  };

  this.entry = urlParams.entry;
  this.fupAppType = urlParams.fupAppType;
  this.layerType = urlParams.layerType;
  this.businessParams = {
    actName: urlParams.actName,
    actId: urlParams.actId,
    actGroupName: urlParams.actGroupName,
    routerPath: urlParams.routerPath,
    from: urlParams.from || urlParams.utm_source,
    theme: urlParams.theme,
    payType: urlParams.payType,
    institutionId: urlParams.institutionId,
    tokenTime: urlParams.tokenTime,
    activityId: urlParams.activityId,
    scene: urlParams.scene,
    Swimlane: urlParams.Swimlane
  };
  this.system = getSystem_2();
  this.isIOS = this.system === 'ios';
  this.isAndroid = this.system === 'android';
  var uaInfo = getUA_1();
  var osVersion = uaInfo.osVersion,
      appVersion = uaInfo.appVersion;
  this.osVersion = osVersion;
  this.appName = getApp_1.getApp(urlParams.utm_campaign);
  var ua = navigator.userAgent.toLowerCase();

  if (/micromessenger/i.test(ua)) {
    if (/miniprogram/i.test(ua)) {
      var ctype = urlParams.ctype;
      var mina_name = urlParams.mina_name;

      if (ctype === 'wm_wxapp') {
        this.appName = 'WXAPP_WM';
      } else if (mina_name === 'mt-weapp') {
        this.appName = 'WXAPP_MT';
      } else {
        this.appName = 'WXAPP_UNKNOW';
      }
    } else {
      this.appName = 'WXH5';
    }
  }

  this.isInConch = this.appName === 'conch';
  this.isInWaimai = this.appName === 'waimai';
  this.isInMeituan = this.appName === 'group';
  this.isInDianping = this.appName === 'dianping-nova';
  this.isInDaxiang = this.appName === 'daxiang';
  this.isInMaicai = this.appName === 'mtmaicai';
  this.isInWXH5 = this.appName === 'WXH5';
  this.isEhcModal = urlParams.ehcShowModal === 'true';
  this.isInWXAPP = false;

  if (this.appName === 'WXAPP_WM' || this.appName === 'WXAPP_MT' || this.appName === 'WXAPP_UNKNOW') {
    this.isInWXAPP = true;
  }

  this.commonParams = {
    entry: this.entry,
    cityId: getParam('ci', 'cityid') || 0,
    token: getParam('token', 'mt_c_token', 'lt', 'oops', 'thirdlogin_token'),
    ci: getParam('ci'),
    uuid: getParam('iuuid', 'uuid', 'dpid'),
    app: this.appName,
    version: getParam('version_name', 'wm_appversion') || appVersion,
    platform: this.isInWXAPP ? 'weixin' : this.system,
    location: '',
    wx_openid: this.isInWXAPP ? getParam('openId', 'openid') : '',
    wx_expoId: this.isInWXAPP ? getParam('openIdCipher') : ''
  };

  if (this.appName === 'WXAPP_MT') {
    this.commonParams.wx_appid = 'wxde8ac0a21135c07d';
  } else if (this.appName === 'WXAPP_WM') {
    this.commonParams.wx_appid = 'wx2c348cf579062e56';

    try {
      var wxPayParams = JSON.parse(decodeURIComponent(getParam('wx_pay_params'))) || {};
      this.commonParams.wx_expoId = wxPayParams.openIdCipher;
    } catch (err) {
      var Owl = window.Owl;
      Owl && Owl.addError && Owl.addError({
        name: '外卖小程序获取openIdCipher失败',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
    }
  }

  if (window.H5guard) {
    try {
      this.commonParams.wx_h5_fingerprint = window.H5guard.getfp();
    } catch (err) {
      var Owl = window.Owl;
      Owl && Owl.addError && Owl.addError({
        name: 'H5guard.getfp()获取指纹信息失败',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
    }
  }

  try {
    if (!this.isNative) {
      return;
    }

    getFingerprint().then(function (fingerprint) {
      _this.commonParams.fingerprint = fingerprint || '';
    }).catch(function (error) {
      var Owl = window.Owl;
      Owl && Owl.addError && Owl.addError({
        name: 'getFingerprint获取指纹信息失败',
        msg: JSON.stringify(error)
      }, {
        level: 'warn'
      });
    });
  } catch (error) {
    var Owl = window.Owl;
    Owl && Owl.addError && Owl.addError({
      name: 'getFingerprint获取指纹信息失败',
      msg: JSON.stringify(error)
    }, {
      level: 'warn'
    });
  }

  var latAndLon = (getParam('latlon') || '').split(',');

  if (latAndLon.length === 1) {
    var lat = getParam('lat') || getParam('wm_actual_latitude') || getParam('wm_latitude') || 0;
    var lon = getParam('lng') || getParam('wm_actual_longitude') || getParam('wm_longitude') || 0;
    this.commonParams.location = "".concat(lat, "_").concat(lon);
  } else {
    var _latAndLon = _slicedToArray(latAndLon, 2),
        _latAndLon$ = _latAndLon[0],
        _lat = _latAndLon$ === void 0 ? '0' : _latAndLon$,
        _latAndLon$2 = _latAndLon[1],
        _lon = _latAndLon$2 === void 0 ? '0' : _latAndLon$2;

    this.commonParams.location = "".concat(_lat || 0, "_").concat(_lon);
  }
});

var initEnv = new Env();
var env = Object.assign(initEnv, Object.assign({}, initEnv.businessParams));

export { env as default };
